/**
 * Decodes common HTML entities in a string.
 * Use when CMS/API returns HTML with escaped entities (e.g. &lt;a&gt; instead of <a>)
 * so that v-html can render it as real HTML. Safe to call on already-valid HTML.
 *
 * @param html - String that may contain HTML entities
 * @returns String with entities decoded
 */
export function decodeHtmlEntities(html: string): string {
  if (!html || typeof html !== 'string') {
    return '';
  }
  return html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&');
}
